import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { NaploService } from '../naplo.service';
import { DataService } from '../../data.service';

// NAPLO – NAV-ban beküldött bevallások (Ügyfélportál, csak olvasás). Mint az ÜPO / eBEV „Bevallások
// lekérdezése”: egy időszak beküldött bevallásai és a PDF-jük. A lekérés KAÜ-belépéssel jár (lassú),
// ezért háttérfeladat; az eredmény (lista + PDF) eltárolódik, a megnyitáshoz később nem kell belépni.
// Backend: naplo.js `/upo/…`, naplo-nav-upo.js `bevallasokLetolt`.
@Component({
  selector: 'app-naplo-upo-bevallasok',
  templateUrl: './upo-bevallasok.component.html',
  styleUrls: ['../naplo-shared.scss'],
})
export class UpoBevallasokComponent implements OnInit, OnDestroy {
  tol = `${new Date().getFullYear()}-01-01`;
  ig = new Date().toISOString().slice(0, 10);
  sorok: any[] = [];
  szuro = '';
  fut = false;
  halad: any = null;
  betolt = false;
  private sub?: Subscription;
  private ugyfel: string | null = null;

  constructor(private naplo: NaploService, private data: DataService, private toast: ToastController) {}

  get aktiv() { return this.naplo.aktiv; }

  async ngOnInit() {
    await this.naplo.init();
    //  Ügyfélváltáskor a lista is az új ügyfélé.
    this.sub = this.naplo.aktiv$.subscribe((a) => { if (a.ugyfelId !== this.ugyfel) { this.ugyfel = a.ugyfelId; this.lista(); } });
  }
  ngOnDestroy() { this.sub?.unsubscribe(); }

  /** A már lekért (tárolt) bevallások az időszakra. */
  async lista() {
    if (!this.aktiv.ugyfelId) { this.sorok = []; return; }
    this.betolt = true;
    try {
      const r: any = await this.naplo.get(`/upo/bevallasok/${this.aktiv.ugyfelId}?tol=${this.tol}&ig=${this.ig}`);
      this.sorok = r?.sorok || [];
    } catch (e: any) { this.uzen(e?.error?.error || 'Nem sikerült betölteni a listát.', true); }
    finally { this.betolt = false; }
  }

  get szurtSorok() {
    const s = this.szuro.trim().toLowerCase();
    return s ? this.sorok.filter((x) => `${x.kod} ${x.nev} ${x.idoszak} ${x.iktato_szam} ${x.allapot}`.toLowerCase().includes(s)) : this.sorok;
  }

  /** Friss lekérés a NAV Ügyfélportálról (háttérfeladat). `ujra`: a már letöltött PDF-eket is újra. */
  async lekeres(ujra = false) {
    if (!this.aktiv.ugyfelId || this.fut) return;
    if (!this.tol || !this.ig || this.tol > this.ig) { this.uzen('Add meg az időszakot.', true); return; }
    this.fut = true; this.halad = { uzenet: 'Indul…' };
    const ugyfelId = this.aktiv.ugyfelId;
    try {
      const id = await this.naplo.feladatIndit(`/upo/bevallas-inditas/${ugyfelId}`, { tol: this.tol, ig: this.ig, ujra });
      if (!id) throw new Error('Nem sikerült elindítani a lekérést.');
      const f = await this.naplo.feladatVar(id, (h) => { this.halad = h; });
      const e = f?.eredmeny || {};
      if (this.aktiv.ugyfelId === ugyfelId) await this.lista();
      this.uzen(`${e.darab ?? 0} beküldött bevallás az Ügyfélportálon${e.uj_pdf ? `, ${e.uj_pdf} PDF letöltve` : ''}${e.pdf_hiba ? `, ${e.pdf_hiba} PDF nem tölthető le` : ''}.`, !!e.pdf_hiba);
    } catch (e: any) { this.uzen(e?.error?.error || e?.message || 'A lekérés nem sikerült.', true); }
    finally { this.fut = false; this.halad = null; }
  }

  /** A NAV funkciókódja olvashatóan (ALAPBEVALLAS, JAVITO_BEVALLAS, HELYESBITES, ONELLENORZES…). */
  funkcio(f: string | null): string {
    const k = String(f || '').toUpperCase();
    const t: Record<string, string> = { ALAPBEVALLAS: 'alap', JAVITO_BEVALLAS: 'javító', HELYESBITES: 'helyesbítés', HELYESBITO_BEVALLAS: 'helyesbítő', ONELLENORZES: 'önellenőrzés',
      ISMETELT_ONELLENORZES: 'ismételt önellenőrzés', PANASZ: 'panasz' };
    return t[k] || k.toLowerCase().replace(/_/g, ' ') || '—';
  }

  pdf(s: any) {
    this.data.megnyitFajl(`/api/naplo/upo/bevallas-pdf/${this.aktiv.ugyfelId}/${encodeURIComponent(s.iktato_szam)}`, `${s.kod} ${s.idoszak || ''}`);
  }

  private async uzen(message: string, hiba = false) {
    (await this.toast.create({ message, duration: hiba ? 6000 : 3500, color: hiba ? 'danger' : 'success', position: 'top' })).present();
  }
}
